// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2yt7K","title":"ClientInsurance_title__xr2N0","itemText":"ClientInsurance_itemText__1Onfn"};